import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const AgeValidator = (
    control: AbstractControl
): ValidationErrors | null => {
    const inputDate = control.value;

    // Verifica si el valor está presente y si es una cadena en formato de fecha ISO
    if (!inputDate || typeof inputDate !== 'string') {
        return {
            invalidFormat: true,
        };
    }

    // Convierte la fecha de entrada en un objeto Date
    const birthDate = new Date(inputDate);
    if (isNaN(birthDate.getTime())) {
        return { invalidDate: true };
    }

    // Calcula la fecha límite para ser mayor de 18 años
    const currentDate = new Date();
    const ageLimitDate = new Date(
        currentDate.getFullYear() - 18,
        currentDate.getMonth(),
        currentDate.getDate()
    );

    // Compara la fecha de nacimiento con la fecha límite
    if (birthDate > ageLimitDate) {
        return { underage: true };
    }

    // Si es mayor de edad, no hay errores
    return null;
};
